<template>
    <div id="myDateShow">
        <div class="title">{{collectorId!=null?"编辑":"新增"}}采集商信息</div>
        <div id="dataShow">
            <div class="line">
                <div class="key">采集商名称</div>
                <div class="value">
                    <el-input class="w500" v-model="collector.name" maxlength="50" show-word-limit placeholder="请填写采集商名称"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">机构类型</div>
                <div class="value">
                    <el-select class="w500" v-model="collector.organizationType" placeholder="请选择机构类型">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="line">
                <div class="key">采集品类</div>
                <div class="value">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group v-model="checkedCategorys" @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="city in categorys" :label="city" :key="city">{{city}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div class="line">
                <div class="key">联系地址</div>
                <div class="value">
                    <el-input class="w500" v-model="collector.address" maxlength="100" show-word-limit placeholder="请填写联系地址"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">营业执照</div>
                <div class="value">
                    <el-upload
                            :headers="headers"
                            ref="upLoad"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="upLoadAnswerSeccess"
                            :limit="1"
                            accept=".pdf,.jpg,.png,.jpeg"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.BusinessLicense"
                            :file-list="businessLicenseFiles"
                            drag
                            :action="baseURL+'/collection/upload'"
                            :auto-upload="false">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip"></div>
                    </el-upload>
                </div>
            </div>
            <div class="line">
                <div class="key">企业Logo</div>
                <div class="value">
                    <el-upload
                            :headers="headers"
                            ref="upLoadLogo"
                            :on-progress="progress"
                            :on-change="upLoadLogo"
                            :on-success="upLoadLogoSeccess"
                            class="upload-demo"
                            name="multipartFile"
                            accept=".pdf,.jpg,.png,.jpeg"
                            :limit="1"
                            :data="uploadParam.BusinessLicense"
                            :file-list="logoFiles"
                            drag
                            :action="baseURL+'/collection/upload'"
                            :auto-upload="false">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip"></div>
                    </el-upload>
                </div>
            </div>
            <div class="line">
                <div class="key"></div>
                <div class="value">
                    <el-button type="text" @click="dialogFormVisible = true">绑定采集员</el-button>
                    <el-dialog title="查询采集员" :visible.sync="dialogFormVisible">
                        <el-form>
                            <el-form-item label="手机号码">
                                <el-input v-model="queryPhone" clearable maxlength="11" minlength="11"  placeholder="请输入手机号" size="50"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名">
                                <el-input v-model="collectorUser.username" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary"  @click="queryUser">查询</el-button>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取 消</el-button>
                            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <div class="line">
                <div class="key">采集员</div>
                <div class="value">
                    <el-input class="w500" v-model="collectorUser.username" :disabled="true"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">联系电话</div>
                <div class="value">
                    <el-input class="w500" v-model="collectorUser.phoneNumber"  :disabled="true" ></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key"></div>
                <div class="value">
                    <el-button type="primary" size="medium" @click="submit">保存</el-button>
                </div>
            </div>
        </div>
        <div class="but">
            <el-button type="danger" size="small" @click="backClick">返回</el-button>
        </div>
    </div>
</template>

<script>
    import {queryCollectorById,getUserByPhone,addupdateCoupons, newVue} from "../../network/collector";
    const categorys = ['大米', '红米', '南瓜','贝贝瓜','冬瓜','芋头','水培菜','白玉姜','荔枝','龙眼','绿宝瓜','葡萄','小番茄','粉番茄','三华李','脐橙','沃柑','嘉宝果','释迦果','无花果','茶叶','咖啡','咖啡原料','龙眼干'];
    export default {
        name: "CollectorInsert",
        data(){
            return{
                collector: {},
                collectorId:null,
                options: [
                    {
                        value:"1",
                        label:"国有企业"
                    },
                    {
                        value:"2",
                        label:"集体所有制企业"
                    },
                    {
                        value:"3",
                        label:"股份制企业"
                    },
                    {
                        value:"4",
                        label:"联营企业"
                    },
                    {
                        value:"5",
                        label:"个人独资企业"
                    }
                ],//机构类型
                categorys:categorys,//品类合集
                checkedCategorys:[],//品类选择集合
                isIndeterminate:true,
                checkAll: false,
                collectorUser:{},//采集员信息
                fileList: [],
                baseURL:newVue.baseURL,//請求地址
                uploadParam:{
                    BusinessLicense:{type:"BusinessLicense"},
                    EnterpriseLogo:{type:"EnterpriseLogo"}
                },
                businessLicenseFiles: [],//营业执照文件
                logoFiles: [],//企业logo文件
                headers: {
                },
                dialogFormVisible: false,//是否展示对话框
                formLabelWidth: '20px',//对话框大小
                queryPhone:"",//查询手机号
                collectorUser:{},
                loadingMsg:null,

            }
        },
        created() {
            newVue.obj = this;
            this.authorization=newVue.obj.common.loginInfo.jwtToken;
            this.headers.Authorization = this.authorization;
            this.common.HeaderLocationTwo.href = "/collector/list";
            this.common.HeaderLocationTwo.name = "采集管理";
            this.common.HeaderLocationThree.name = "新增采集商";
            if (this.$route.params.id!=null){
                this.collectorId = this.$route.params.id;
                this.common.HeaderLocationThree.name = "编辑采集商";
                queryCollectorById(this.collectorId).then(res => {
                    let list = [];
                    this.collector = res.data;
                    for (let i = 0; i < this.collector.category.split(',').length; i++) {
                        list.push(this.collector.category.split(',')[i]);
                    }
                    this.collectorUser = {
                        "id":res.data.userId,
                        "username":res.data.username,
                        "phoneNumber":res.data.phone,
                    };
                    this.checkedCategorys = list;
                    if (res.data.businessLicenseFile){
                        this.businessLicenseFiles = [];
                        this.businessLicenseFiles.push(res.data.businessLicenseFile);
                    }
                    if (res.data.logoFile){
                        this.logoFiles = [];
                        this.logoFiles.push(res.data.logoFile);
                    }
                })
            }
        },
        methods: {
            backClick(){
                this.$router.push("../list");
            },
            handleCheckAllChange(val) {
                this.checkedCategorys = val ? categorys : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.categorys.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.categorys.length;
            },
            upLoadAnswerSeccess(response, file, fileList){
                this.loadingMsg.close();
                this.businessLicenseFiles = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = fileList[i].name;
                        item["id"] = fileList[i].uid;
                        item["fileSize"] = fileList[i].raw?fileList[i].raw.size:fileList[i].fileSize;
                        item["fileType"] = fileList[i].raw?fileList[i].raw.type:fileList[i].fileType;
                        item["associationType"] = "BusinessLicense";
                        item["url"] = fileList[i].response?fileList[i].response.data[0]:fileList[i].url;
                        this.businessLicenseFiles.push(item);
                    }
                }else {
                    this.businessLicenseFiles = [];
                }
            },
            upLoadLogoSeccess(response, file, fileList){
                this.loadingMsg.close();
                this.logoFiles = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = fileList[i].name;
                        item["id"] = fileList[i].uid;
                        item["fileSize"] = fileList[i].raw?fileList[i].raw.size:fileList[i].fileSize;
                        item["fileType"] = fileList[i].raw?fileList[i].raw.type:fileList[i].fileType;
                        item["associationType"] = "EnterpriseLogo";
                        item["url"] = fileList[i].response?fileList[i].response.data[0]:fileList[i].url;
                        this.logoFiles.push(item);
                    }
                }else {
                    this.logoFiles = [];
                }
            },
            //上传营业执照图片
            upLoad (file, fileList) {
                this.$refs.upLoad.submit();
            },
            //上传企业Logo图片
            upLoadLogo(file, fileList){
                this.$refs.upLoadLogo.submit();
            },
            queryUser(){//查询采集员
                getUserByPhone(this.queryPhone).then(res => {
                    if (res.code=="200"){
                        this.collectorUser = res.data;
                    }
                })
            },
            //提交表单
            submit(){
                let entity = {};
                if (this.collectorUser.username == null){
                    this.$confirm('请绑定采集员', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }else if (this.collector.name == null){
                    this.$confirm('请填写采集商名称', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }else if (this.collector.organizationType == null){
                    this.$confirm('请选择机构类型', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }else if (this.collector.organizationType == null){
                    this.$confirm('请选择机构类型', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }else if (this.checkedCategorys.length == 0){
                    this.$confirm('请勾选采集品类', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }
                entity = this.collector;
                entity["category"] = this.checkedCategorys.toString();
                entity["userId"] = this.collectorUser.id;
                entity["businessLicenseFile"] = this.businessLicenseFiles[0];
                entity["logoFile"] = this.logoFiles[0];
                entity["businessLicenseId"] = this.businessLicenseFiles[0].id;
                entity["corporateLogoId"] = this.logoFiles[0].id;
                entity["phone"] = this.collectorUser.phoneNumber;
                addupdateCoupons(entity).then(res => {
                    if (res.code=="200"){
                        this.$router.back();
                    }
                })

            },
            progress(){
                this.loadingMsg = this.$loading({
                    lock: true,
                    text: '正在上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
        }
    }
</script>

<style scoped>
    @import "../../assets/css/data.css";
    .w500{
        width: 500px;
    }
</style>
